import { render } from "./ViewsEmployees.vue?vue&type=template&id=812d1f76"
import script from "./ViewsEmployees.vue?vue&type=script&lang=js"
export * from "./ViewsEmployees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__